export default "__VITE_ASSET__BaqmHPdZ__"